<style src="./style.scss">
</style>

<script>
  import HeaderLogo from "@assets/images/header_logo.png";
  import Icon from "svelte-icon";
  import BackButton from "@assets/icons/back.svg";
  import LockIcon from "@assets/icons/lock.svg";
  import Steps from "./steps";

  export let showBackButton = false;
  export let checkoutHeader = false;
  export let goBack = () => null;
  export let steps = [];
  export let activeStep = null;
  export let checkedStep = -1;
</script>

<div class="{'header  checkout-header'}">
  {#if showBackButton}
    <div class="header__back-button" on:click="{goBack}">
      <Icon data="{BackButton}" size="24px" stroke="transparent" />
    </div>
  {/if}

  <img src="{HeaderLogo}" alt="" />

  {#if steps.length > 0}
    <Steps indexes="{steps}" active="{activeStep}" checked="{checkedStep}" />
  {/if}
</div>
